import React, { useEffect, useState } from "react";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(true);

  useEffect(() => {
    const showBox = () => {
      if (!document.cookie.includes("cookiePrefs=")) {
        setVisible(true);
        setTimeout(() => setAnimate(true), 50); // allow DOM to render before animation
      }
    };
    const timer = setTimeout(showBox, 5000); // 4 second delay
    return () => clearTimeout(timer);
  }, []);

  const savePreferences = () => {
    const preferences = { analytics, marketing };
    const expiry = 60 * 60 * 24 * 30;
    document.cookie = `cookiePrefs=${JSON.stringify(preferences)}; max-age=${expiry}; path=/`;
  };

  const handleAccept = () => {
    savePreferences(); // Save cookie on accept
    setVisible(false);
  };

  const handleDecline = () => {
    setAnalytics(false);
    setMarketing(false);
    // 🚫 Do NOT save cookie so banner shows again on reload
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className={`position-fixed bottom-0 end-0 bg-white border shadow-lg p-4 m-3 rounded transition-custom ${
        animate ? "slide-in" : ""
      }`}
      style={{
        maxWidth: "600px",
        zIndex: 1050,
        transform: animate ? "translateX(0)" : "translateX(120%)",
        transition: "transform 0.6s ease-in-out",
      }}
    >
      <div className="d-flex align-items-center mb-2">
        <i className="bx bx-cookie fs-2 text-primary me-2"></i>
        <h5 className="mb-0 text-blue">Cookies Consent</h5>
      </div>
      <p className="mb-3">
        We use cookies to enhance your experience. You can manage your preferences below.{" "}
        
      </p>

      <div className="form-check form-switch mb-2 d-none">
        <input
          className="form-check-input"
          type="checkbox"
          id="analyticsSwitch"
          checked={analytics}
          onChange={() => setAnalytics(!analytics)}
        />
        <label className="form-check-label" htmlFor="analyticsSwitch">
          Analytics Cookies
        </label>
      </div>

      <div className="form-check form-switch mb-3 d-none">
        <input
          className="form-check-input"
          type="checkbox"
          id="marketingSwitch"
          checked={marketing}
          onChange={() => setMarketing(!marketing)}
        />
        <label className="form-check-label" htmlFor="marketingSwitch">
          Marketing Cookies
        </label>
      </div>

      <div className="d-flex justify-content-between gap-3">
        <button className="btn btn-primary fs-12" onClick={handleAccept}>
          Accept
        </button>
        <button className="btn btn-outline-primary fs-12" onClick={handleAccept}>
        Accept what is necessary
        </button>
        <button className="btn btn-outline-primary fs-12" onClick={handleDecline}>
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
